import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { AgencyBrandAdd } from '../agency-brand-add/agency-brand-add';
import { BusinessAccountDto } from '@/app/common/general-types/business-account.dto';
import { ImageService } from '@/app/services/image/image.service';
import { AlertService } from '@/app/atoms/alert/alert.service';

@Component({
  selector: 'oba-agency-brands',
  imports: [AgencyBrandAdd],
  templateUrl: './agency-brands.html',  
  styleUrl: './agency-brands.scss',
})
export class AgencyBrands {

  @Output() stepComplete = new EventEmitter<boolean>();

  brandModal = signal<boolean>(false);

  allBrands = signal<BusinessAccountDto[]>([]);

  /** Services */
  public imageService = inject(ImageService);
  private alertService = inject(AlertService);
  /** Services - END */

  launchAddBrand() {
    this.brandModal.set(true);
  }

  onBrandAdded(brand: BusinessAccountDto) {
    console.log('------> onBrandAdded()', brand);
    this.brandModal.set(false);
    this.allBrands.update(list => [brand, ...(list ?? [])]);
  }

  brandsStepComplete() {
    if (this.allBrands().length > 0) {
      this.stepComplete.emit(true);
    } else {
      this.alertService.alert({
        title: 'No brands added',
        message: 'Please add at least one brand to continue',
        confirmText: 'OK',
        cancelText: 'Cancel',
        type: 'alert',
        icon: 'info',
      });
    }
  }
}
